<template>
  <div class="container mx-auto">
    <div class="bg-white rounded  mt-3 shadow-md">
      <div class="bg-yellow-900 px-6 py-4 rounded">
        <h1 class="text-gray-100 text-lg font-bold text-center uppercase">Naše země v pravěku</h1>
      </div>
      <div class="flex flex-wrap">
        <!--Starší doba kamenná-->
        <div class="px-6 py-4">
          <h2 class=" text-base font-bold text-yellow-900 uppercase">1. Starší doba kamenná</h2>
          <h3 class=" text-sm text-gray-800">(asi před půl milionem let)</h3>
          <div>
            <h3>Naši prapředci:</h3>
            <ul class=" list-disc list-inside">
              <li>sbírali plody</li>
              <li>lovili zvěř</li>
              <li>používali kamenné nástroje</li>
              <li>poznali oheň</li>
            </ul>
          </div>
        </div>
        <!--/Starší doba kamenná-->
        <!--Mladší doba kamenná-->
        <div class="px-6 py-4">
          <h2 class=" text-base font-bold text-yellow-900 uppercase">2. Mladší doba kamenná</h2>
          <h3 class=" text-sm text-gray-800">(asi 5000 let př. n. l.)</h3>
          <div>
            <h3>Naši prapředci:</h3>
            <ul class=" list-disc list-inside">
              <li>živili se zemědělstvím</li>
              <li>obdělávali pole</li>
              <li>chovali dobytek</li>
              <li>stále používají kamenné nástroje</li>
            </ul>
          </div>
        </div>
        <!--/Mladší doba kamenná-->
        <!--Doba bronzová-->
        <div class="px-6 py-4">
          <h2 class=" text-base font-bold text-yellow-900 uppercase">3. Doba bronzová</h2>
          <h3 class=" text-sm text-gray-800">(asi 2000 let př. n. l.)</h3>
          <div>
            <h3>Naši prapředci:</h3>
            <ul class=" list-disc list-inside">
              <li>živili se zemědělstvím</li>
              <li>chovali dobytek</li>
              <li>používají nástroje z bronzu</li>
              <li>první řemesla</li>
            </ul>
          </div>
        </div>
        <!--/Doba bronzová-->
        <!--Doba železná-->
        <div class="px-6 py-4">
          <h2 class=" text-base font-bold text-yellow-900 uppercase">4. Doba železná</h2>
          <h3 class=" text-sm text-gray-800">(asi 400 let př. n. l.)</h3>
          <div>
            <h3>Naši prapředci:</h3>
            <ul class="list-disc list-inside">
              <li>živili se zemědělstvím</li>
              <li>chovali dobytek</li>
              <li>řemeslo a obchod</li>
              <li>používali železné nástroje</li>
              <li>Obyvatelé</li>
            </ul>
            <h4 class="font-bold">Keltové</h4>
            <ul class="list-disc list-inside">
              <li>stavěli opevněná hradiště (oppida)</li>
              <li>razili první mince u nás</li>
              <li>znali hrnčířský kruh</li>
            </ul>
            <h4 class="font-bold">Germáni</h4>
            <ul class="list-disc list-inside">
              <li>zemědělci</li>
              <li>řemeslníci</li>
              <li>válečníci</li>
            </ul>
          </div>
        </div>
        <!--/Doba železná-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Pravek"
};
</script>

<style lang="scss" scoped></style>
